import { IdEnum, type ITripTerminus } from "@b2bportal/core-types";

export const ZERO_FIAT_AMOUNT = {
  currencyCode: "QAR",
  currencySymbol: "QAR ",
  value: 0,
};

export const DEFAULT_FLIGHT_ORIGIN: ITripTerminus = {
  id: {
    code: {
      regionType: "airport",
      code: "DOH",
    },
    Id: IdEnum.Flight,
  },
  label: "Doha, Qatar (DOH)",
  trackingProperties: {},
};
